<template>
  <div class="content">
    <h1 v-if="eventName" class="content-title">
      {{ decodeURI(eventName) }}
    </h1>
    <h1 v-else class="content-title">
      Join event
    </h1>
    <div class="card">
      <p>
        You have been invited to join
        <span v-if="eventName">{{ decodeURI(eventName) }}</span
        ><span v-else>an event</span>. Please click the button below to confirm
        you want to join.
      </p>
      <button v-if="!joining" class="btn btn-primary" @click="join()">
        <i class="fas fa-sign-in-alt"></i>
        <span class="ml-5">Join now</span>
      </button>
      <button v-else class="btn btn-primary disabled">
        <i class="fas fa-spinner fa-spin"></i>
        <span class="ml-5">Joining...</span>
      </button>
    </div>
  </div>
</template>

<script>
import { db } from "../../lib/firebase.js";

export default {
  name: "Join",
  components: {},
  props: ["eventId", "eventName"],
  data() {
    return { joining: false };
  },
  methods: {
    async join() {
      this.joining = true;
      await db
        .collection("events")
        .doc(this.eventId)
        .collection("members")
        .doc(this.user.uid)
        .set({ name: this.user.displayName, email: this.user.email });
      setTimeout(() => {
        this.$router.push({ name: "Home" });
      }, 2000);
    },
    getImgUrl(pic) {
      return require("../../assets/img/" + pic + ".jpg");
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    user() {
      return this.$store.getters.getUser;
    },
  },
  async mounted() {},
};
</script>

<style scoped></style>
